import { useEffect } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { Option } from '@organs/Select'
import SeverityDegrees from '@enums/SeverityDegrees'
import {
  getHardGradeName,
  getProbabilityName,
} from '@modals/RiskMapModal/Dangers/nameUtils'
import InjuryPossibilities from '@enums/InjuryPossibilities'
import { useCalculateSignificanceMutation } from '@services/riskMaps'

const useCalculateSignificance = ({ watch }: UseFormReturn, index: number) => {
  const hardGrade: Option<SeverityDegrees> | undefined = watch(
    getHardGradeName(index)
  )
  const probability: Option<InjuryPossibilities> | undefined = watch(
    getProbabilityName(index)
  )

  const [calculateSignificance, { data: calculateSignificanceData }] =
    useCalculateSignificanceMutation()

  useEffect(() => {
    if (hardGrade && probability) {
      void calculateSignificance({
        injuryPossibility: probability?.value,
        injurySeverity: hardGrade?.value,
      })
    }
  }, [calculateSignificance, hardGrade, probability])

  return calculateSignificanceData
}

export default useCalculateSignificance
